module.exports = __webpack_public_path__ + "static/media/simplonbp-medium-webfont.5067e888.woff";